<template>
    <div class="vehicles" v-if="hasVehicles">
        <div class="vehicles-title" v-if="title">{{ title }}</div>
        <div
            class="vehicles-fields"
            v-for="(segment, segmentIndex) in leg.Segments"
            :key="segmentIndex">
            <Vehicle
                v-for="(vehicle, vehicleIndex) in segment.Vehicles?.filter(hasLicensePlate)"
                :vehicle="vehicle"
                :key="vehicleIndex"
                :name="getVehicleFieldName(legIndex, segmentIndex, vehicleIndex)"
                :vehicleNumber="vehicleIndex + 1" />
        </div>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { FerryLeg } from '@/api/Cart/cart.interfaces';
    import {
        hasLicensePlate,
        getVehicleFieldName,
    } from '@/components/checkoutPageV3/Sections/Products/Ferry/Form/FerryVehicle.helpers';
    import Vehicle from './Vehicle.vue';

    export default defineComponent({
        name: 'FerryVehicles',
        components: { Vehicle },
        methods: { getVehicleFieldName, t, hasLicensePlate },
        props: {
            leg: { type: Object as PropType<FerryLeg>, required: true },
            legIndex: { type: Number, required: true },
            isOutbound: { type: Boolean, required: true },
            showTitle: { type: Boolean, required: true },
        },
        setup(props) {
            const hasVehicles = computed(() =>
                props.leg.Segments.some(
                    (seg) => (seg.Vehicles ?? []).filter(hasLicensePlate).length > 0
                )
            );

            const title = computed(() => {
                const { showTitle, isOutbound } = props;
                if (showTitle) {
                    const key = isOutbound ? 'shared.outbound' : 'shared.homebound';
                    return t({ key });
                }
                return undefined;
            });

            return {
                hasVehicles,
                title,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Vehicles.scss';
</style>
